import React from "react";
import styles from "./Hero.module.css";

const Hero: React.FC = () => {
    return (
        <section className={`${styles.heroSection} d-flex align-items-center`}>
            {/*<video*/}
            {/*    className={styles.heroVideo}*/}
            {/*    src="/images/banner/homeVideo.mp4"*/}
            {/*    autoPlay*/}
            {/*    loop*/}
            {/*    muted*/}
            {/*    playsInline*/}
            {/*/>*/}
            <div className={`${styles.mainContainer} container`}>
                <div className="row">
                    <div className="col-lg-6 col-md-8 col-12">
                        <div className={styles.heroContent}>

                            <h1 className={`${styles.heroTitle} ${styles.slideLeft1}`}>
                                Premium Corals for Every Reef Tank
                            </h1>

                            <p className={`${styles.heroSubtext} ${styles.slideLeft2}`}>
                                Hand-selected, healthy corals shipped with care.
                            </p>

                            <div
                                className={`${styles.ctaButtonsContainer} d-flex gap-3 mt-4 flex-wrap ${styles.slideUp3}`}
                            >
                                <a href="/#scrollTarget" className={`btn btn-primary btn-lg  ${styles.orderButton}`}>
                                    Shop Products
                                </a>

                                <a href="tel:5145459049" className="phone-link btn btn-outline-light btn-lg">
                                    Contact Us To Order
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
